import AuthenticatedResource from 'resources/public/AuthenticatedResource';

export default class EventProductListingResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/events/:event_id/event_product_listings' as const;

  readonly id: number | undefined = undefined;
  readonly listing_id: number | undefined = undefined;
  readonly product_id: number | undefined = undefined;
  readonly identifier: string = '';
  readonly allocation_quantity: number | undefined = undefined;
  readonly available_amount: number | undefined = undefined;
  readonly storefront_visible: boolean | undefined = undefined;
  // SELL06 — product option axes, all active SKUs (with per-context
  // availability), and this listing's per-SKU allocations.
  readonly options: { name: string; values: string[] }[] | undefined = undefined;
  readonly variants: { id: number; label: string; available_amount?: number | null; available?: boolean }[] | undefined = undefined;
  readonly variant_allocations: { product_variant_id: number; label: string; allocation_quantity: number; sold_count: number }[] | undefined = undefined;

  pk() {
    if (this.listing_id) return `listing-${this.listing_id}`;
    return this.id ? `product-${this.id}` : undefined;
  }
}
